// extracted by mini-css-extract-plugin
export default {"root":"Chart_root__Fmtpf"};